module.exports = __webpack_public_path__ + "img/Upload.c13bdeb7.svg";